var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFullscreen),expression:"isFullscreen"}],staticClass:"exit-fullscreen",class:{
    'exit-fullscreen-keyboard': _vm.showKeyboard,
  }},[_c('b-button',{attrs:{"pill":"","variant":"light"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('BIconFullscreenExit')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }